/**
 * Name of the user-managed filter (stored in the user's config) that the home
 * page, header, and mobile nav single out as the "pending transactions"
 * shortcut. Must match the row the user keeps in the filter registry; if that
 * filter is renamed, update this constant in lockstep.
 */
export const PENDING_FILTER_NAME = "Pending transactions";
